<div
  class="relative p-[10px] border-2 border-solid border-transparent transition-border duration-300 ease-in-out hover:!border-2 hover:!border-solid hover:!border-primary w-[100%] cursor-pointer"
  [id]="'pagemodule' + content.id" [ngStyle]="{
    backgroundColor: styles.colors['other']['background'],
  }" [ngClass]="{
    '!border-2 !border-solid !border-primary': isSelectedModule,
  }">
  <div>
    <div class="text-center text-md font-bold mb-5" [attr.style]="buildStyle('text', items[0].styles?.text)">
      {{ items[0].value.text }}
    </div>
    <div class="text-center">
      @if (items[1].value.url) {
      <img [src]="items[1].value.url" class="w-[100%] object-contain" alt="Company logo" />
      }
    </div>
    <div class="text-center text-md mb-5" [attr.style]="buildStyle('text', items[2].styles?.text)">
      {{ items[2].value.text }}
    </div>
    <div class="text-center text-xs mb-5" [attr.style]="buildStyle('text', items[3].styles?.text)"
      [innerHTML]="items[3].value.text | lineBreak">
    </div>
    <div class="flex justify-center gap-4 mb-4">
      <a href="https://www.regenesis.ag/privacy-policy" target="_blank"
        class="text-[10px] text-gray-500 hover:text-primary transition-colors">Privacy
        Policy</a>
      <a href="/terms" target="_blank" class="text-[10px] text-gray-500 hover:text-primary transition-colors">Terms of
        Service</a>
    </div>
  </div>

  <div>
    <div class="text-center p-[10px] border-2 border-solid mt-[5px] mb-[5px] bg-transparent"
      [attr.style]="buildStyle('button', items[4].styles?.button)">
      <a [ngStyle]="{
          color: 'inherit',
          fontSize: 'inherit',
          fontWeight: 'inherit',
          fontFamily: 'inherit',
          backgroundColor: 'inherit',
          textAlign: 'inherit',
        }" [href]="items[4].value.url" target="_blank" class="no-underline">{{ items[4].value.label }}</a>
    </div>
  </div>
</div>